var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext1_1",
    x: 0.273438,
    width: 40,
    height: 40,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext1_1_i",
    d: "M11.2734 14H16.5985C16.9459 12.2883 18.4592 11 20.2735 11C22.0877 11 23.601 12.2883 23.9484 14H29.2734C30.5161 14 31.5234 15.0074 31.5234 16.25V29C31.5234 30.2426 30.5161 31.25 29.2734 31.25H11.2734C10.0308 31.25 9.02344 30.2426 9.02344 29V16.25C9.02344 15.0074 10.0308 14 11.2734 14ZM22.3954 14C22.0865 13.1261 21.2531 12.5 20.2735 12.5C19.2938 12.5 18.4604 13.1261 18.1515 14H22.3954ZM10.5234 19.5803L10.5475 19.581C10.7071 20.6665 11.6436 21.5 12.7734 21.5L17.2734 21.5C17.2734 20.6716 17.945 20 18.7734 20H21.7734C22.6019 20 23.2734 20.6716 23.2734 21.5L27.7734 21.5C28.9033 21.5 29.8398 20.6665 29.9994 19.581L30.0234 19.5803V16.25C30.0234 15.8358 29.6877 15.5 29.2734 15.5H11.2734C10.8592 15.5 10.5234 15.8358 10.5234 16.25V19.5803ZM22.5234 22.25V21.5C22.5234 21.0858 22.1877 20.75 21.7734 20.75H18.7734C18.3592 20.75 18.0234 21.0858 18.0234 21.5V22.25H22.5234ZM18.0234 23V23.75C18.0234 24.1642 18.3592 24.5 18.7734 24.5H21.7734C22.1877 24.5 22.5234 24.1642 22.5234 23.75V23H18.0234ZM17.2734 23L12.7734 23C11.9291 23 11.1501 22.7211 10.5234 22.2503V29C10.5234 29.4142 10.8592 29.75 11.2734 29.75H29.2734C29.6877 29.75 30.0234 29.4142 30.0234 29V22.2503C29.3968 22.7211 28.6178 23 27.7734 23L23.2734 23V23.75C23.2734 24.5784 22.6019 25.25 21.7734 25.25H18.7734C17.945 25.25 17.2734 24.5784 17.2734 23.75V23Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/Briefcase.180ac010.svg";
export { ForwardRef as ReactComponent };